var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup1261152240(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1112,
    height: 214,
    viewBox: "0 0 1112 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2825_38214)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 556,
    cy: 107,
    rx: 476,
    ry: 27,
    fill: "url(#paint0_linear_2825_38214)",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2825_38214)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 556.5,
    cy: 107.5,
    rx: 341.5,
    ry: 7.5,
    fill: "url(#paint1_linear_2825_38214)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2825_38214",
    x: 0,
    y: 0.00012207,
    width: 1112,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40,
    result: "effect1_foregroundBlur_2825_38214"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2825_38214",
    x: 200,
    y: 85.0001,
    width: 713,
    height: 45,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_2825_38214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2825_38214",
    x1: 556,
    y1: 80.0001,
    x2: 556,
    y2: 134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD55F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53AFEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2825_38214",
    x1: 556.5,
    y1: 100,
    x2: 556.5,
    y2: 115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AD55F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53AFEC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1261152240);
export default __webpack_public_path__ + "static/media/group-1261152240.dd2c5d7d10e7c75f7e925911d8159572.svg";
export { ForwardRef as ReactComponent };